import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { PathEnum } from 'app/enums/pathEnum';

/**
 * NoIndexInterceptor
 * 
 * This interceptor selectively adds X-Robots-Tag headers
 * Strategy:
 * - Prevents indexing of menu pages only
 * - Allows indexing of establishment pages for better local SEO
 * - Works alongside robots.txt and meta tags
 * 
 * This helps with:
 * - Local SEO for restaurants
 * - Protecting dynamic menu content
 * - Building online presence for establishments
 */
@Injectable()
export class NoIndexInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Check if current route is a menu route
        const isMenuRoute = this.router.url.includes('/'+ PathEnum.MENU +'/');
        
        if (isMenuRoute) {
            // Add X-Robots-Tag header only for menu routes
            const modifiedRequest = request.clone({
                setHeaders: {
                    'X-Robots-Tag': 'noindex, nofollow'
                }
            });
            return next.handle(modifiedRequest);
        }
        
        // For establishment routes, proceed without no-index headers
        return next.handle(request);
    }
} 